<template>
	<div class="okxActivity">
		<img class="posterBg" :src="httpImg + '/activeXP/fxhhd.png'" />
		<!-- <img class="posterBg" src="../../assets/turntable/posterBg3-1.png"/>
		<img class="posterBg" src="../../assets/turntable/posterBg3-2.png"/>
		<img class="posterBg" src="../../assets/turntable/posterBg3-3.png"/> -->
		<!-- <button class="button" @click="buttonClick(0)">填寫收件地址</button> -->
		<button class="button2" @click="buttonClick(1)"></button>
		<div class="copyList">
			<button class="copy1" @click="copyClick($event,'https://t.me/jgzproen')"></button>
			<button class="copy2" @click="copyClick($event,'https://twitter.com/JGZPRO')"></button>
			<button class="copy3" @click="copyClick($event,'https://t.me/jgzproen')"></button>
			<!-- <button class="copy4" @click="copyClick($event,'https://chat.whatsapp.com/HobclROKu2HGZKTkoewmUN')"></button> -->
		</div>
		<img class="ewm" :src="httpImg + `/activeXP/2122.png`" />

		<div class="alert" v-show="alertShow">
			<span>{{message}}</span>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';

	import Clipboard from 'clipboard'
	export default {
		data() {
			return {
				loading: true,
				alertShow: false,
				message: '',
			}
		},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				httpImg: state => state.httpImg
			}),
		},
		mounted() {},
		methods: {
			showAlert(message) {
				this.message = message;
				this.alertShow = true;
				setTimeout(() => {
					this.alertShow = false;
				}, 1500);
			},
			//复制
			copyClick(event, txt) {
				let clipboard = new Clipboard(event.target, {
					text: () => txt
				})
				console.log(clipboard)
				// this.showAlert('已复制')
				clipboard.on('success', e => {
					this.showAlert('复制成功')
				})
				clipboard.on('error', e => {
					this.showAlert('复制失败')
				})
			},

			//
			buttonClick(i) {
				if (i == 0) {
					window.location.href = 'https://jinshuju.net/f/M78pXE'
				} else {
					window.location.href = 'https://down.jgzpro.com/sign-in/?inviteCode=VFISAR'
				}

			},

		}
	}
</script>

<style scoped lang="less">
	button {
		border: none;
		background: none;
	}

	html,
	body {
		background: #f7ebb7;
	}

	.okxActivity {
		width: 100%;
		position: relative;
		background: #f7ebb7;
		overflow: hidden;
		padding-bottom: 15vw;

		.posterBg {
			margin: 0;
			width: 100%;
			height: auto;
			display: block;
		}

		.button {
			margin: 30px 0 0 95px;
			align-items: center;
			text-align: center;
			font-size: 34px;
			color: #fff;
			font-weight: bold;
			width: 560px;
			height: 88px;
			border-radius: 44px;
			background: #FA9A0A;
			z-index: 7;
			display: block;
		}

		.button2 {
			position: fixed;
			bottom: 19px;
			left: 19px;
			width: 712px;
			height: 150px;
			background: url('../../assets/turntable/posterbutton2.png');
			background-size: 100% 100%;
			z-index: 7;
		}

		.ewm {
			position: absolute;
			left: 9vw;
			top: 430vw;
			width: 21vw;
			height: 21vw;
			z-index: 3;
		}

		.copyList {
			position: absolute;
			z-index: 2;
			width: 100%;
			height: 120vw;
			top: 324vw;
			left: 0;

			button {
				// background:#FA9A0A;
				position: absolute;
				height: 50px;
			}

			.copy1 {
				width: 44%;
				left: 33%;
				top: 119vw;
			}

			.copy2 {
				width: 49%;
				left: 42vw;
				top: 145vw;
			}

			.copy3 {
				width: 40%;
				left: 51vw;
				top: 155vw;
			}

			.copy4 {
				width: 90%;
				left: 5%;
				top: 230vw;
			}
		}
	}
</style>